<app-card [errorSubtitle]="'not_found.message' | translate"></app-card>
